import { HypotheticalInsuranceSourceKind } from '@/types/schema';
import { getPulidKind, PulidKind } from '@/utils/pulid';

import { MapHypotheticalInsuranceToDataInput } from '../HypotheticalILITModal.utils';

export function getSourceEntityDetails({
  formData: { transferFromId },
}: MapHypotheticalInsuranceToDataInput): {
  sourceKind: HypotheticalInsuranceSourceKind;
  sourceEntityID?: string;
  sourceIndividualID?: string;
  error?: string;
} {
  const sourcePulid = getPulidKind(transferFromId);

  if (sourcePulid === PulidKind.Entity) {
    return {
      sourceKind: HypotheticalInsuranceSourceKind.Entity,
      sourceEntityID: transferFromId,
    };
  } else if (sourcePulid === PulidKind.ClientProfile) {
    return {
      sourceKind: HypotheticalInsuranceSourceKind.Individual,
      sourceIndividualID: transferFromId,
    };
  } else {
    return {
      error: 'Invalid source ID',
      sourceKind: HypotheticalInsuranceSourceKind.Individual,
    };
  }
}
